/**
 * @generated SignedSource<<dbc11c79a2fa7e03580e6f6e88e95914>>
 * @relayHash 42c1f0f238e4ad92d4e813a2f1345025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraIteration = "ITERATION_1" | "ITERATION_2" | "ITERATION_DYNAMIC" | "%future added value";
export type useNaturalLanguageToJqlQuery$variables = {
  cloudId: string;
  iteration: JiraIteration;
  naturalLanguageInput: string;
  project?: string | null | undefined;
};
export type useNaturalLanguageToJqlQuery$data = {
  readonly jira: {
    readonly naturalLanguageToJql: {
      readonly generatedJQL: string | null | undefined;
      readonly generatedJQLError: {
        readonly __typename: "JiraGeneratedJqlInvalidError";
      } | {
        readonly __typename: "JiraServerError";
      } | {
        readonly __typename: "JiraUIExposedError";
        readonly message: string | null | undefined;
      } | {
        readonly __typename: "JiraUnsupportedLanguageError";
      } | {
        readonly __typename: "JiraUsageLimitExceededError";
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    };
  };
};
export type useNaturalLanguageToJqlQuery = {
  response: useNaturalLanguageToJqlQuery$data;
  variables: useNaturalLanguageToJqlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "iteration"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "naturalLanguageInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "project"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "iteration",
        "variableName": "iteration"
      },
      {
        "kind": "Variable",
        "name": "naturalLanguageInput",
        "variableName": "naturalLanguageInput"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "project"
          }
        ],
        "kind": "ObjectValue",
        "name": "searchContext"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "generatedJQL"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "message"
},
v8 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useNaturalLanguageToJqlQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "concreteType": "JiraJQLFromNaturalLanguage",
                "kind": "LinkedField",
                "name": "naturalLanguageToJql",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "generatedJQLError",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "type": "JiraUIExposedError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "JiraUsageLimitExceededError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "JiraGeneratedJqlInvalidError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "JiraUnsupportedLanguageError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "JiraServerError"
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.naturalLanguageToJql"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useNaturalLanguageToJqlQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraJQLFromNaturalLanguage",
            "kind": "LinkedField",
            "name": "naturalLanguageToJql",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "generatedJQLError",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "type": "JiraUIExposedError"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b",
    "metadata": {},
    "name": "useNaturalLanguageToJqlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fc551bf7230ae7a4cf420565001ddefc";

export default node;
